// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"749e583e","478":"ef214f65","551":"82195239","626":"fff24d64","687":"ae45f0bb","889":"d1bc03ef"}[chunkId] + ".chunk.js";
};